import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import "lib-flexible/flexible";
// import "./assets/js/environment";

import './assets/js/common'
import "./assets/js/sensorsdata.min.js";
import Vant from "vant";
import "vant/lib/index.css";
import axios from 'axios'
Vue.use(Vant);

import { getToken } from './assets/js/getAppInfo'

import wx from "weixin-js-sdk"
Vue.prototype.$wx = wx
Vue.config.productionTip = false
Vue.config.ignoredElements = [
    'wx-open-launch-app',
]


axios.get('/.well-known/getHost.json').then(function (res) {
    var sensors = require('sa-sdk-javascript');
    Vue.server_url = res.data['sensordata'];
    sensors.init({
        // server_url: 'https://sensordata-api.qiuer.org:30443/sa?project=default',
        server_url: res.data['sensordata'],
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        show_log: false,
        send_type: 'beacon',
        heatmap: {
            //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
            clickmap: 'default',
            //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
            scroll_notice_map: 'default'
        }
    });
    sensors.quick('autoTrack'); //用于采集 $pageview 事件。
    Vue.prototype.$sensors = sensors;
}).then(() => {
    init();
}).catch(() => {
    init();
})

function init() {
    if (systemInfo.environment === 'APP') {
        getToken()
            .then((res) => {
                Vue.token = res;
                new Vue({
                    router,
                    render: h => h(App)
                }).$mount("#app");
            })
    } else {
        console.log("非app 登录init error");
        new Vue({
            router,
            render: (h) => h(App),
        }).$mount("#app");
    }

}
// init();

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        window.document.title = to.meta.title
    }
    next()
})